export default "https://cdn-static.gokick.com/assets/2d58d4130188e7931b16ced23acf41c7838443e2/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";